import { Component, Input, OnInit, OnDestroy, Inject } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileViewExplorerComponent } from 'src/app/file-view-explorer/file-view-explorer.component';
import { ToastrService } from 'ngx-toastr';
import { TabChangeService } from 'src/app/services/tab-change.service';
import { ModalTabVisibilityService } from '../../services/modal-tab-visibility.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-casespecimen',
  templateUrl: './casespecimen.component.html',
  styleUrls: ['./casespecimen.component.scss']
})
export class CasespecimenComponent implements OnInit, OnDestroy {
//@Input() caseInfoData;
specimenList = [];
testList=[1,2,4,43,434]
  micrographscount: any;
  
  // Modal tab management
  private destroy$ = new Subject<void>();
  private tabChangeSubscription: Subscription;
  private componentName = 'case 360 prime';
  private isActiveTab = true;
  private modalWasOpen = false;
  private currentModalRefs: any[] = [];
  
  constructor(@Inject('caseData') public caseInfoData: any,private ngxUiLoaderService: NgxUiLoaderService,private service: CommonService
      ,private modalService: NgbModal,    private toastr: ToastrService, private tabChangeService: TabChangeService, private modalTabVisibility: ModalTabVisibilityService) { }
islabadmin:boolean = false;
  ngOnInit(){
    // Subscribe to tab changes
    this.tabChangeSubscription = this.tabChangeService.tabChange$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((tabName: string) => {
      this.isActiveTab = tabName.toLowerCase() === this.componentName.toLowerCase();
      setTimeout(() => {
        if (this.isActiveTab) {
          this.modalTabVisibility.hideForeignOwnedModals('data-case360-modal');
          this.showModals();
        } else {
          this.hideModals();
        }
      }, 0);
    });
    
    this.specimenList=[]
    if(this.caseInfoData !== undefined && this.caseInfoData !== ''&& this.caseInfoData.Case.ResultDetails !== undefined ){
      this.islabadmin=this.caseInfoData['islabadmin'];
      if(this.caseInfoData.Case?.ResultDetails?.Result?.ObservationSet?.length > 0){
        this.specimenList= this.caseInfoData.Case.ResultDetails.Result.ObservationSet
      }else{
        this.specimenList=[this.caseInfoData.Case.ResultDetails.Result.ObservationSet]
      }
      for (let i = 0; i < this.specimenList.length; i++) {
        if(this.specimenList[i].TestDetails!=undefined)
        {
        if(Array.isArray(this.specimenList[i].TestDetails.Test)){
          this.specimenList[i].TestDetails.Test =  this.specimenList[i].TestDetails.Test
        }else{
          this.specimenList[i].TestDetails.Test = [this.specimenList[i].TestDetails.Test]
        }
      }
      }
      console.log(this.specimenList);
    }else{
      this.specimenList=[]
    }
  }

  getPendingTest(testArray){
if(testArray.length>0){
 let pending= testArray.filter(va => va.Status.toLowerCase() !== 'fulfilled')
 this.micrographscount= pending.length;
 return pending.length;
}
  }
  viewCaseFile(item){
let report=item?.ObservationDetails?.File
    let obj=
      {
        "RequestID": report.PresentationData,
        "Type": report.Category,
        "RequestGUID": report.FileGUID,
        "LabOrgGUID":this.caseInfoData.laboratory.OrganizationGUID,
        "CaseGUID": this.caseInfoData['CaseGUID'],
        "DeploymentsKey":this.caseInfoData['DeploymentKey']
      }
      this.ngxUiLoaderService.start()
      this.service.viewCases360DXReport(obj).subscribe(data=>{
        this.ngxUiLoaderService.stop()
        if( data.StatusMessage !== null &&data.StatusMessage.toLowerCase() !== "failed"){
          if(data['FileContent'] !== null){
            'data:application/pdf;base64,'+data['FileContent'];
            let namemodal={
              name:report.ReportName,
              fullfile:data['FileContent']
            }
            this.service.auditsave("View", "", "Viewed dx report :-"+report.ReportName, "case", this.caseInfoData['CaseGUID'], "Caseinfo tab ,deployment key :-"+this.caseInfoData.DeploymentKey);
            const modalRef = this.modalService.open(FileViewExplorerComponent
              , {
              windowClass: "myCustomModalViewfilecase360",
              backdrop: "static",
              keyboard: false
            });
            modalRef.componentInstance.fileData =namemodal ;
            this.currentModalRefs.push(modalRef);
            
            modalRef.result.then(() => {
              this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
            }, (reason) => {
              this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
            });
            
            // Add data attribute to identify the modal and backdrop
            this.modalTabVisibility.tagOwned('data-case360-modal', 'myCustomModalViewfilecase360');
            
            this.modalWasOpen = true;
                }else{
                  this.ngxUiLoaderService.stop();
                  this.toastr.warning('Data not Found', "Alert", {
                    positionClass: "toast-bottom-right",
                    timeOut: 4000,
                  });
                }
        }else{
          this.ngxUiLoaderService.stop();
          this.service.copyableToastError(data.FileContent,'Failed');
        }
  
      },error=>{
        this.ngxUiLoaderService.stop()
      })
  }
  
  ngOnDestroy() {
    // Close all open modals when component is destroyed
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentModalRefs = [];
    }
    
    this.destroy$.next();
    this.destroy$.complete();
    if (this.tabChangeSubscription) {
      this.tabChangeSubscription.unsubscribe();
    }
  }
  
  hideModals() {
  const result = this.modalTabVisibility.hideOwned('data-case360-modal', {
    hasOpenRefs: this.currentModalRefs?.length > 0,
    windowClasses: ["myCustomModalClasscase360audit","myCustomModalViewfilecase360","myCustomModalClasscase360hl7","myCustomModalClassFTPcase360","myCustomModalClasscase360","Mode_Bootcase360","viewstagescasemsg360","viewstagescase360","messageiotcase360","PopupScreencase360"],
    nestedOwnerAttrs: ['data-case360-nested-modal'],
  });
  this.modalWasOpen = result.modalWasOpen;
}

showModals() {
  this.modalTabVisibility.showOwned('data-case360-modal', {
    modalWasOpen: this.modalWasOpen,
    hasOpenRefs: this.currentModalRefs?.length > 0,
    windowClasses: ["myCustomModalClasscase360audit","myCustomModalViewfilecase360","myCustomModalClasscase360hl7","myCustomModalClassFTPcase360","myCustomModalClasscase360","Mode_Bootcase360","viewstagescasemsg360","viewstagescase360","messageiotcase360","PopupScreencase360"],
    nestedOwnerAttrs: ['data-case360-nested-modal'],
  });
}

}
